import promotion from '@resources/js/components/promotion'
import initJSLinks from '@resources/js/js-links'
import initGalleries from '@resources/js/components/galleries'

import FormView from '@resources/js/components/form/FormView'
import FormStore from '@resources/js/components/form/FormStore'
import FormPresenter from '@resources/js/components/form/FormPresenter'
import handleCalendarFormSubmit from '@resources/js/helpers/handleCalendarFormSubmit'
import { getBcomOrExpediaPartnerType } from '@resources/js/components/promotion/helpers/getPartnerType'
import { parse } from '@formkit/tempo'
import '@resources/js/analytics'

const partnerType = getBcomOrExpediaPartnerType()

promotion({
	links: {
		active: !!shared.options.dest_id,
		type: partnerType,
	},
	backbtn: {
		active: !!shared.options.bbcl && !!shared.options.dest_id,
		type: partnerType,
	},
	tab_change: {
		active: !!shared.options.dest_id,
		type: partnerType,
	},
	// popup: {
	// 	active: !!shared.options.dest_id,
	// },
})

initJSLinks()

initGalleries()

// form
const formElement = document.querySelector('.js-form')

if (formElement) {
	const formsStore = new FormStore()

	const HOLLIDAY_NETWORK_IDS = [60, 62]
	const NEW_YEAR_LISTING_IDS = [909]
	const CHRISTMAS_LISTING_IDS = [937]

	const NEW_YEAR_DATES = { checkIn: '2026-12-30', checkOut: '2027-01-02' }
	const CHRISTMAS_DATES = { checkIn: '2026-12-24', checkOut: '2026-12-26' }

	const isNewYearListing = NEW_YEAR_LISTING_IDS.includes(shared.options.lid)
	const isChristmasListing = CHRISTMAS_LISTING_IDS.includes(shared.options.lid)

	const useCustomDates =
		HOLLIDAY_NETWORK_IDS.includes(shared.options.nid) &&
		(isNewYearListing || isChristmasListing)

	const calendarConfig = {}

	if (useCustomDates) {
		const dates = isNewYearListing ? NEW_YEAR_DATES : CHRISTMAS_DATES

		const formDefaultDates = [
			parse(dates.checkIn), // check in
			parse(dates.checkOut), // check out
		]

		formsStore.setProperty('checkIn', formDefaultDates[0])
		formsStore.setProperty('checkOut', formDefaultDates[1])

		calendarConfig.defaultDate = formDefaultDates
	}

	const formView = new FormView(formElement, { calendarConfig })
	const formPresenter = new FormPresenter(formView, formsStore)

	formPresenter.on('form-submit', formData =>
		handleCalendarFormSubmit({ partnerType, formData })
	)
}
